const SHELL_SELECTOR_KEY = 'shell';

export interface UserInfo {
	tenant: string;
	email: string;
	email_verified: boolean;
	family_name: string;
	given_name: string;
	name: string;
	preferred_username: string;
	roles: string[];
	sub: string;
}

export function isModernShell() {
	return localStorage.getItem(SHELL_SELECTOR_KEY) === 'modern';
}

export function setModernShell(modern: boolean) {
	if (modern) {
		localStorage.setItem(SHELL_SELECTOR_KEY, 'modern');
	} else {
		localStorage.removeItem(SHELL_SELECTOR_KEY);
	}

	window.location.reload();
}
